import React from 'react'
import { motion, useScroll, useTransform, useSpring} from 'framer-motion';
import pinos from "../assets/bosque.png";
import img_footer from '../assets/img_footer.webp'

function Footer() {
  return (
    <div className="cont-footer">
        <div className="div-img-footer">

            

            <div className="img-footer" />
            <motion.img src={pinos} alt="" className="separador-pinos-2"
                      initial={{ opacity: 0, y: 80 }} 
                      whileInView={{ opacity: 1, y: 0}}
                      transition={{ duration: 0.8 }} />

                      <div className="text-footer">
                <h1>D & E</h1>
                <h1>¡Los esperamos!</h1>
                
            </div>
        </div>
         
        <div className="barra-footer">
            <p className="text-sm">Diana y Emmanuel. 2026.</p>
            <p className="text-sm"> Desarrollado con ♥ por los novios.
            </p>
        </div>
        
    </div>
  )
}

export default Footer